import React from 'react';
import { Feature } from '@tencent/workbench';
import { BackColorFeature as ToolbarBackColorFeature } from '@src/framework/workbench/ui/back-color/back-color-feature';
import { config } from '@src/framework/workbench/ui/back-color/config';
import { FONT_BACK_COLOR_ICON } from '@src/framework/workbench/drawer/image';
import BackColorDropdown, { DRAWER_BACK_COLOR } from '@src/framework/workbench/drawer/components/dropdown/back-color-dropdown';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/text/font/back-color/config';

@Feature()
export class BackColorFeature extends ToolbarBackColorFeature {
    id = config.id;
    config = config;

    public renderItemNum(element: JSX.Element) {
        return (
            <BackColorDropdown
                icon={FONT_BACK_COLOR_ICON}
                colorBtnStyle={{ background: this.getColor() }}
                style={{ minWidth: 62 }}
                onClick={() => this.onClick()}
                dropdownContent={element}
                tooltip={FORM_CONFIGS[0].tooltip}
            />
        );
    }
}
